import { useState } from 'react';

export const useModal = () => {
  const [isOpened, setIsOpened] = useState(false);

  const onClose = () => {
    setIsOpened(false);
  };
  const onOpen = () => {
    setIsOpened(true);
  };

  return {
    isOpened,
    onOpen,
    onClose,
  };
};
